import React from 'react'

import type { CompanyContract } from '../../../api/companies/types'
import Tag from '../content/Tag'
import SanitizeHTML from '../layout/SanitizeHtml'
import './styles.css'
import { useI18N } from '../../../libraries/i18n/hook'
import ExternalLink from '../layout/ExternalLink'
import TagGroup from '../content/TagGroup'

type Props = { contract: CompanyContract, languageCode?: string }
const ContractCard:React.FC<Props> = ({ contract, languageCode }) => {

  const { t } = useI18N()
  return (
    <div>
      <div className='md:flex border-b border-solid border-soft-green pt-4 pb-6 md:mb-3'>
        <div className='flex items-center gap-x-3 md:block md:max-w-[5%]'>
          <img src={contract.iconSrc} alt={contract.name} className='h-8 w-8 md:h-14 md:w-14' />
          <div className='md:hidden'><h5>{contract.name}</h5></div>
        </div>
        <div className='mt-4 md:mt-0 md:max-w-[60%] md:ml-4 md:mr-4'>
          <div className='hidden md:block'><h5>{contract.name}</h5></div>
          {contract.tags && (
            <div className='-ml-2'>{contract.tags?.map(tag => <Tag outlined iconSrc={tag.iconSrc} key={tag.label}><span className='text-black'>{tag.label}</span></Tag>)}</div>
          )}
          {contract.applicantLevels && (
            <div className='mt-2'>
              <p className='text-xs md:text-sm font-semibold mb-2 text-black'>{t('companies.applicants.profile', undefined, languageCode)}</p>
              <TagGroup>
                {contract.applicantLevels.map(level => <Tag outlined solid key={level.label}>{level.label}</Tag>)}
              </TagGroup>
            </div>
          )}
          {contract.info && (
            <div className='mt-3 small-paragraph text-black'>
              <SanitizeHTML html={contract.info} />
            </div>
          )}
          {contract.externalLinks && (
            <div className='mt-2'>
              {contract.externalLinks.map((link) => (
                <p key={link.label} className='font-semibold mt-2 text-black'>
                  <ExternalLink url={link.url}>
                    {link.label}
                  </ExternalLink>
                </p>
              ))}
            </div>
          )}
        </div>
        {contract.datesInfo && (
          <div className='mt-4 md:mt-0 md:max-w-[35%] flex gap-y-1 flex-col'>
            {contract.datesInfo.map((dateInfo) => (
              <div key={dateInfo.title} className='md:ml-4'>
                <DateInfoBox {...dateInfo} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

const DateInfoBox = ({ title, description, iconSrc }: { title: string, description: string, iconSrc: string }) => (
  <div className='shadow bg-soft-green rounded-md p-4 flex gap-x-2 min-w-[250px]'>
    <img src={iconSrc} alt={title} className='h-5 w-5' />
    <div className='cols-span-2 text-black'>
      <p className='font-semibold text-xs md:text-sm'>{title}</p>
      <p className='mt-1 text-2xs md:text-xs'>{description}</p>
    </div>
  </div>
)

export default ContractCard
